<script lang="ts">
  // components
  import PlaidModal from "@retailer/svelte/Payments/PlaidModal.svelte";

  // stores
  import { updatingBankAccount } from "@retailer/stores/BankAccountStore";
  import { userDisabled } from "@retailer/svelte/stores/DwollaIdentityStore";

  // types
  import { PlaidCustomization } from "@retailer/types/Plaid";

  // props
  export let customization: PlaidCustomization = PlaidCustomization.Default;
  export let afterSuccess: () => void = () => {};
  export let disabled: boolean = false;

  // data
  let showPlaidModal = false;
  let plaidModalLoading = false;

  // functions
  const updateShowPlaidModal = () => {
    showPlaidModal = true;
    plaidModalLoading = true;
  };

  const afterExit = () => {
    showPlaidModal = false;
  };

  const onLoad = () => {
    plaidModalLoading = false;
  };

  // reactives
  $: plaidModalOpening = showPlaidModal && plaidModalLoading;
  $: spin = plaidModalOpening || $updatingBankAccount;

</script>

<button
  data-testid={"add-payment-method"}
  class={"fizz-button"}
  class:fizz-button-spinner={spin}
  on:click|preventDefault={updateShowPlaidModal}
  disabled={spin || $userDisabled || disabled}
>
  Add payment method
</button>

{#if showPlaidModal}
  <PlaidModal {afterSuccess} {afterExit} {onLoad} {customization} />
{/if}
